/**
 * SearchDirectory
 */
export default class SearchDirectory {
    rootPath = '';
    isLoading = false;
    isTypeModalOpen = false;
    openedLocations = [];
    form =null;
    type = null;
    typeModalOffset = 0;
    resultsCount = 0;
    resultsCountPanelDocked = false;
    tripLayerInitialized = false;
    disablePopups = false;
    constructor(root, type, resultsCount) {
        this.rootPath = root;
        this.type = type;
        this.resultsCount = resultsCount;
    }
    async init() {
        this.form = document.getElementById('search-directory-form');
        this.setResultsCountPanelDocked();
        if (window.addEventListener) {
            window.addEventListener('popstate', () => {
                if (window.history.state === null) {
                    location.reload();
                } else {
                    window.location = window.history.state.path + '&ajax_reload=true';
                }
            });
        }
        // if we got opened locations in URL

        const openedLocations = this.readOpenedLocations();
        if (openedLocations) {
            await this.reopenLocations();
        }
        const updateMapTypeEvent = new CustomEvent('update-map-type', {
            detail: {
                type: this.type,
            },
        });
        window.dispatchEvent(updateMapTypeEvent);
        if (this.type === 'trip') {
            setTimeout(() => {
                this.updateVisibleMarkers();
            }, 1000);
        }
        this.loadMapLocations();
    }

    async reopenLocations() {
        const openedLocations = this.readOpenedLocations();

        if (openedLocations) {
            this.isLoading = true;
            // Loop through each location sequentially
            this.disablePopups = true;
            for (const location of this.openedLocations) {
                // Wait for openLocation to complete before proceeding
                await this.openLocation(null, location);

                // Repopulate links after each openLocation call
                const links = document.querySelectorAll('[data-location]');

                // Check if the current location is still valid in the updated links
                const validLink = Array.from(links).find(link => link.dataset.location === location);
                if (!validLink) {
                    console.warn(`Location ${location} is no longer valid after repopulating links.`);
                }
            }

            this.disablePopups = false;
            const lodge = this.readLastClickedLodge();
            if (lodge && this.openedLocations.length > 1) {
                await this.openLodgePage(null, lodge);
            }
            this.isLoading = false;
        }
    }

    /**
     * Model closing / opening methods
     */
    openTypeModal() {
        this.isTypeModalOpen = true;
    }

    closeTypeModal() {
        this.isTypeModalOpen = false;
    }

    /**
     * Selector methods
     */
    selectType(type) {
        const url = new URL(window.location.href);
        url.searchParams.set('filter-type', type);
        // redirect
        window.location.href= url.toString();
    }

    loadResultsCount() {
        try {
            this.resultsCount = JSON.parse(this.form.dataset.resultsCount);
        } catch (error) {
            console.error('Error in SearchSentence init', error);
            this.resultsCount = 0;
        }
    }

    async openLocation(e, location, page = 1) {
        // check if e is an Event has preventDefault method
        if (e) {
            e.preventDefault();
            const sender = e.target;
            this.location = sender.dataset.location;
            this.saveLastClickedLodge(this.location)
        } else {
            this.location = location
        }

        if (!this.openedLocations.includes(this.location)) {
            this.openedLocations.push(this.location);
            this.saveOpenedLocations();
        }

        const listElement = document.querySelectorAll('[data-pegasus-filterable="' + this.location + '"]' );
        if (listElement.length > 0) {
            const listItems = listElement[0].querySelectorAll('li');
            if (listItems.length > 0) {
                let dir = 'open';
                // hide the list if it visible
                // native js check for visibility
                if (listItems[0].offsetParent === null) {
                    listElement[0].style.display = 'block';
                } else {
                    dir = 'close';
                    listElement[0].style.display = 'none';
                    const index = this.openedLocations.indexOf(this.location);
                    if (index !== -1) {
                        this.openedLocations.splice(index, 1);
                    }
                    const furtherRemovals = [];
                    for (let i = 0; i < this.openedLocations.length; i++) {
                        let locationToCheck = this.openedLocations[i];
                        let elements = listElement[0].querySelectorAll(`ul[data-pegasus-filterable="${locationToCheck}"]`);

                        if (elements.length > 0) {
                            elements.forEach(e => {
                                e.style.display = 'none';
                            });
                            furtherRemovals.push(locationToCheck)
                        }
                    }
                    if (furtherRemovals.length) {
                        furtherRemovals.forEach(w => {
                            const index = this.openedLocations.indexOf(w);
                            if (index !== -1) {
                                this.openedLocations.splice(index, 1);
                            }
                        })
                    }
                    this.saveOpenedLocations();

                }
                if (dir === 'close') {
                    this.disablePopups = true;
                }
                await this.openLodgePage(e, this.location);
                this.disablePopups = false;
                return;
            }
        }

        if (location) {
            await this.handleSubmit(e ,['data-pegasus-filterable="' + this.location + '"'], location, page);
            if (e && page >1) {
                // remove sender from the page
                e.target.remove();
            }
        } else {
            let timer;

            if (timer) {
                clearTimeout(timer);
            }
            timer = setTimeout(() => {
                this.handleSubmit(e ,['data-pegasus-filterable="' + this.location + '"']);
            }, 100);
        }

    }

    /**
     *
     * @param url
     */
    async openLodgePage(e, location) {
        if (window.innerWidth < 768) {
            return;
        }
        if (e) {
            e.preventDefault();
        }

        this.location = location;

        this.saveLastClickedLodge(this.location)

        await this.loadMapLocations();
    }

    /**
     * Adjusts type modal position if off screen 
     */
    setTypeModalPosition() {
        if (!this.$refs?.typeModal) return;

        const rightOverflow = this.getElementOverflow(this.$refs.typeModal);

        this.typeModalOffset = Math.ceil(rightOverflow > 0 ? -rightOverflow : 0);
    }

    /**
     * Checks if the results count panel is docked 
     */
    setResultsCountPanelDocked() {
        this.resultsCountPanelDocked = this.$refs.resultsCountPanel.getBoundingClientRect().top <= (this.$refs.navPanel.clientHeight + 3);
    }

    updateVisibleMarkers() {
        // Get all result elements
        if (this.type !== 'trip') {
            return;
        }
        let visibleCoordinates = [];
        // Check each result to see if it's in the viewport
        const result = this.getElementWithLargestVisibleArea(document.querySelectorAll('.Trip_Result'));
        if (result) {
            const coordinates = JSON.parse(result.getAttribute('data-coordinates'));
            visibleCoordinates = visibleCoordinates.concat(coordinates);
        }
        if (visibleCoordinates.length === 0 && document.querySelectorAll('.Trip_Result').length > 0 && !this.tripLayerInitialized) {
            // If no results are in the viewport, use the first result
            const coordinates = JSON.parse(document.querySelectorAll('.Trip_Result')[0].getAttribute('data-coordinates'));
            visibleCoordinates = visibleCoordinates.concat(coordinates);
            this.tripLayerInitialized = true
        }

        // Update map with visible coordinates
        if (visibleCoordinates.length > 0) {
            this.resetMapLocations();
            const updateMapLocationsEvent = new CustomEvent('update-map-locations', {
                detail: {
                    locations: visibleCoordinates,
                    type: this.type,
                },
            });

            window.dispatchEvent(updateMapLocationsEvent);
        }
    }

    getElementWithLargestVisibleArea(els) {
        let maxVisibleArea = 0;
        let elementWithMaxArea = null;

        els.forEach(el => {
            const rect = el.getBoundingClientRect();
            const viewportWidth = window.innerWidth || document.documentElement.clientWidth;
            const viewportHeight = window.innerHeight || document.documentElement.clientHeight;

            const visibleWidth = Math.max(0, Math.min(rect.right, viewportWidth) - Math.max(rect.left, 0));
            const visibleHeight = Math.max(0, Math.min(rect.bottom, viewportHeight) - Math.max(rect.top, 0));
            const visibleArea = visibleWidth * visibleHeight;

            if (visibleArea > maxVisibleArea) {
                maxVisibleArea = visibleArea;
                elementWithMaxArea = el;
            }
        });

        return elementWithMaxArea;
    }

    resetMapLocations() {
        const resetMapLocationsEvent = new CustomEvent('update-map-locations', {
            detail: {
                locations: [],
                type: this.type,
            },
        });
        window.dispatchEvent(resetMapLocationsEvent);
    }

    async loadMapLocations() {
        console.log('loadMapLocations');
        if (this.type === 'trip') {
            return this.updateVisibleMarkers();
        }
        let activeLocationId = null;

        let zoomLevel = 1;
        if (this.location) {
            const locationElement = document.querySelector(`.SearchDirectoryCard__Button[data-location="${this.location}"]`);

            if (locationElement) {
                activeLocationId = locationElement.dataset.id;
                zoomLevel = locationElement.dataset.zoomLevel;
            }
        }

        const locations = Array.from(document.querySelectorAll('.SearchDirectoryCard__Button')).filter(card => card?.dataset?.lng && card?.dataset?.lat).map(card => {
            return {
                id: card.dataset.id,
                type: (card.dataset.type) ? card.dataset.type : this.type,
                coordinates: [
                    card.dataset.lng,
                    card.dataset.lat,
                ],
                openPopup: activeLocationId === card.dataset.id
            };
        });

        // Read additional markers
        document.querySelectorAll('.SearchDirectoryCard__Button[data-additional-markers]').forEach(card => {
            const additionalMarkers = card.dataset.additionalMarkers;
            if (additionalMarkers) {
                try {
                    const parsedMarkers = JSON.parse(additionalMarkers);
                    parsedMarkers.forEach(marker => {
                        locations.push({
                            id: marker.id,
                            type: (marker.type) ? marker.type : this.type,
                            coordinates: [
                                marker.lng,
                                marker.lat,
                            ],
                            openPopup: false, // These markers should not have popups by default
                        });
                    });
                } catch (error) {
                    console.error('Error parsing additional markers JSON:', error);
                }
            }
        });

        const updateMapLocationsEvent = new CustomEvent('update-map-locations', {
            detail: {
                locations,
                type: this.type,
                setBounds: (!this.location) ? true : false,
                zoomToLevel: zoomLevel,
                disablePopup: this.disablePopups
            },
        });

        window.dispatchEvent(updateMapLocationsEvent);
    }

    /**
     *
     * @param e
     * @param elements
     * @param location
     * @returns {Promise<void>}
     */
    async handleSubmit(e, elements, location, page = 1) {
        if (e) {
            e.preventDefault();
        }
        const formData = new FormData(this.form);
        let urlObject = new URLSearchParams(formData);
        let searchParams = urlObject.toString();
        const url = new URL(window.location.href);
        // remove page parameter
        url.searchParams.delete('filter-page');
        if (location) {
            // replace the location parameter with the new location
            url.searchParams.set('filter-location', location);
            searchParams = url.searchParams.toString();
        }
        if (page > 1) {
            url.searchParams.set('filter-page', page);
            searchParams = url.searchParams.toString();
            await this.fetchContent(url.pathname + '?' + searchParams, elements, true);
        } else {
            await this.fetchContent(url.pathname + '?' + searchParams, elements);
        }
    };

    /**
     * Fetch content from a URL and update specified elements
     * @param {string} url - The URL to fetch data from
     * @param {Array} elements - Elements to update with fetched content
     */
    async fetchContent(url, elements = ['data-pegasus-filterable="filters"', 'data-pegasus-filterable="results"'], append = false) {
        // Set loading state
        this.isLoading = true;
        // Fetch and update content
        if (!append) {
            await this.fetchAndUpdateContent(url, elements);
        } else {
            await this.fetchAndUpdateMoreContent(url, elements);
        }

        // Reset loading state
        this.isLoading = false;
    }

    /**
     * Fetch content and update the DOM asynchronously
     * @param {string} url - The URL to fetch
     * @param {Array} elements - Elements to update
     * @returns {Promise} - Resolves when content is fetched and updated
     */
    fetchAndUpdateContent(url, elements) {
        return new Promise((resolve, reject) => {
            pegasus.ajaxContent(url, elements, {}, () => {
                this.onContentFetched();
                this.loadMapLocations();
                this.loadResultsCount();
                resolve();
            });
        });
    }

    fetchAndUpdateMoreContent(url, elements) {
        return new Promise((resolve, reject) => {
            pegasus.ajaxFetchAndAppendContent(url, elements, {append: true}, () => {
                this.onContentFetched();
                this.loadMapLocations();
                this.loadResultsCount();
                resolve();
            });
        });
    }

    /**
     * Callback after content is fetched
     */
    onContentFetched() {
        // Update the form reference
        this.form = document.getElementById('search-directory-form');
    }



    /**
     * Type dropdown labels
     * @returns {string}
     */
    getTypeLabel() {
        if (this.type === 'location') {
            return 'locations';
        } else if (this.type === 'lodge') {
            return 'lodges';
        } else if (this.type === 'trip') {
            return 'trips';
        } else if (this.type === 'experience') {
            return 'experiences';
        } else if (this.type === 'all') {
            return 'locations and lodges'
        }
        return 'locations';
    }

    /**
     * Saving opened locations
     */
    saveOpenedLocations() {
        sessionStorage.setItem('openedLocations', JSON.stringify(this.openedLocations));
    }

    /**
     * reading back opened locations
     * @returns {string}
     */
    readOpenedLocations() {
        const openedLocations = sessionStorage.getItem('openedLocations');
        if (openedLocations) {
            this.openedLocations = JSON.parse(openedLocations);
        }
        return openedLocations;
    }

    saveLastClickedLodge(lodge) {
        console.log('saved', lodge)
        sessionStorage.setItem('lastClickedLodge', lodge);
    }

    /**
     * reading back opened locations
     * @returns {string}
     */
    readLastClickedLodge() {
        console.log('reading',sessionStorage.getItem('lastClickedLodge') )
        return sessionStorage.getItem('lastClickedLodge') ?? 0;
    }

    goToLastPage() {
        if (pegasus.getCookie('lastPage')) {
            window.location.href = pegasus.getCookie('lastPage');
        } else {
            window.location.href = '/';
        }

    }
}

document.addEventListener('alpine:init', () => {
    Alpine.data('searchDirectory', (root, type, resultsCount) => new SearchDirectory(root, type, resultsCount));
});
